import type LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import ImageViewModelBuilder from '@/Builder/ImageViewModelBuilder';
import ControlViewModelBuilder from '@/Builder/ControlViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';
import { ILinkViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

export default class LinkViewModelBuilder<T = null> extends ControlViewModelBuilder<LinkViewModelT, T> {

    protected properties: ILinkViewModelConstructorParameter;
    private labelBuilder: LabelViewModelBuilder<this>;
    private imageBuilder: ImageViewModelBuilder<this>;

    public constructor(parent?: T) {
        super(parent);
    }

    public withLabel(): LabelViewModelBuilder<this> {
        if (this.labelBuilder == null)
            this.labelBuilder = new LabelViewModelBuilder<this>(this);

        return this.labelBuilder;
    }

    public withImage(): ImageViewModelBuilder<this> {
        if (this.imageBuilder == null)
            this.imageBuilder = new ImageViewModelBuilder<this>(this);

        return this.imageBuilder;
    }

    public withOnClick(onClick: (openInNewWindow: boolean) => any): this {
        this.properties.onClick = onClick;

        return this;
    }

    public withIsToolBarLink(isLink: ObservableOrDefault<boolean>): this {
        this.properties.isToolBarLink = isLink;

        return this;
    }

    public updateProperties(properties: Partial<ILinkViewModelConstructorParameter>): this {
        $.extend(this.properties, properties);
        return this;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): LinkViewModelT {
        const LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');

        if(this.labelBuilder != null)
            this.properties.label = this.labelBuilder.build();

        if (this.imageBuilder != null)
            this.properties.image = this.imageBuilder.build();

        return new LinkViewModel(this.properties);
    }
}